import React from 'react';
import ReactPlayer from 'react-player';

import './AccessTrailerPlayer.scss';

const AccessTrailerPlayer = ({ isPlaying, setIsPlaying }) => {
  return (
    <div className="access-trailer-player">
      <ReactPlayer
        width="100%"
        height="100%"
        light="/images/Trailer_Preview_Image.png"
        url="https://media.raven.news/trailers/2022/01/Access_App_20175801/Access_App_Refresh_video.mp4"
        controls={true}
        onPlay={() => setIsPlaying(true)}
        onPause={() => () => setIsPlaying(false)}
        playing={isPlaying}
        config={{
          file: {
            tracks: [
              {
                kind: 'subtitles',
                src:
                  'https://media.raven.news/trailers/2022/01/Access_App_20175801/Access_App_Refresh_captions.mp4.vtt',
                srcLang: 'en',
                default: true,
                label: 'Closed Captioning',
              },
            ],
          },
        }}
      />
    </div>
  );
};

export default AccessTrailerPlayer;
